import { createContext } from "react";

import { MeGetUserInfoQuery } from "~/__generated__";

export type UserContextUserData = MeGetUserInfoQuery["meGetUserInfo"]["user"];

const UserContext = createContext<{ user: UserContextUserData } | undefined>(undefined);

export default UserContext;
